import { Path } from 'paper';

import { type RetouchingElement } from '..';
import { type GenericShape } from '../../../lib/shapes';

export const getRetouchingShape = (
  element: RetouchingElement,
): GenericShape => {
  const path = new Path(element.svgPath);
  path.translate([element.x, element.y]);
  path.rotate(element.angle);
  path.scale(element.width / 24);

  return {
    data: path.pathData,
    type: 'area',
  };
};
